module.exports = __webpack_public_path__ + "static/media/mg_group_ui_assets_direccion.59b489a4.svg";